import { useTranslation } from "react-i18next";
import { Box } from "@chakra-ui/react";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import SvgContainer from "src/components/SvgContainer";
import { ReactComponent as VideoIcon } from "./video_outlined.svg";
import { ReactComponent as MaximizeIcon } from "./maximize_outlined.svg";

function StationMenu({
  toggleVideoMode,
  handleStationSelect,
  menuRef,
  mode,
  isOpen,
  onClose
}) {
  const { t } = useTranslation();
  const items = [
    {
      label: mode === "video" ? "stationMenu.videoOff" : "stationMenu.videoOn",
      onClick: toggleVideoMode,
      icon: VideoIcon
    },
    {
      label: "stationMenu.maximize",
      onClick: handleStationSelect,
      icon: MaximizeIcon
    }
  ];

  return (
    <Box>
      <Menu
        anchorEl={menuRef}
        isOpen={isOpen}
        onClose={onClose}
        placement="top-end"
        anchorProps={{
          position: "absolute",
          top: "6px",
          right: "14px",
          zIndex: "100"
        }}
        // anchorOrigin={{
        //   vertical: "top",
        //   horizontal: "right"
        // }}
        // transformOrigin={{
        //   vertical: "top",
        //   horizontal: "right"
        // }}
      >
        {items.map((item, i) => {
          return (
            <MenuItem
              key={i}
              onClick={() => {
                item.onClick();
                onClose();
              }}
            >
              <SvgContainer icon={item.icon} fill="primary" marginRight="8px" />
              <MenuItemText>{t(item.label)}</MenuItemText>
            </MenuItem>
          );
        })}
      </Menu>
    </Box>
  );
}

export { StationMenu };
